import { post } from '../index'

export default {
  // 字节跳动小程序配置信息
  getbytedanceSettingUpdate (querys) {
    return post('/bytedance/admin/AdminSetting/settingUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/bytedance.js